// import React, { useEffect, useRef, useState } from 'react';
// import Chart from 'chart.js/auto';
// import './style.scss';
// import { generateRandomColors } from '../../../../../../../../../utils';
// // import Modal from 'react-modal';

// const PieChart = ({ taskData }) => {
//     const [topTwoLabels, setTopTwoLabels] = useState([]);
//     const [isModalOpen, setModalOpen] = useState(false)
//     const chartRef = useRef(null);

//     useEffect(() => {
//         if (chartRef && chartRef?.current && taskData && taskData?.length > 0) {
//             const ctx = chartRef?.current?.getContext('2d');
//             const sortedData = taskData?.sort((a, b) => b.count - a.count);

//             const topTwoLabels = sortedData?.slice(0, 2).map(item => item?.taskName);
//             setTopTwoLabels(topTwoLabels);
//             // const topTwoValues = sortedData?.slice(0, 2).map(item => item?.count);
//             // const othersValue = sortedData?.slice(2).reduce((sum, item) => sum + item?.count, 0);
//             const values = sortedData && sortedData?.map(ele => ele?.count);
//             const labels = sortedData && sortedData?.map(ele => ele?.taskName)

//             const dynamicColors = Array.from({ length: values.length }, () => generateRandomColors());

//             const myChart = new Chart(ctx, {
//                 type: 'pie',
//                 data: {
//                     // labels: sortedData?.length > 2 ? [...topTwoLabels, "Others"] : topTwoLabels,
//                     // labels: sortedData?.length > 2 ? [...topTwoLabels] : topTwoLabels,
//                     labels: labels,
//                     datasets: [{
//                         // data: sortedData?.length > 2 ? [...topTwoValues, othersValue] : topTwoValues,
//                         data: values,
//                         backgroundColor: dynamicColors,
//                         borderColor: dynamicColors,

//                         /* backgroundColor: [
//                             'rgba(133, 113, 244, 1)',
//                             'rgba(9, 114, 121, 1)',
//                             'rgba(48, 206, 216, 1)',
//                         ],
//                         borderColor: [
//                             'rgba(133, 113, 244, 1)',
//                             'rgba(9, 114, 121, 1)',
//                             'rgba(48, 206, 216, 1)',
//                         ], */
//                         borderWidth: 1
//                     }]
//                 },
//                 options: {
//                     responsive: true,
//                     maintainAspectRatio: false,
//                     plugins: {
//                         tooltip: {
//                             callbacks: {
//                                 label: function (context) {
//                                     return context.label + ': ' + context.formattedValue;
//                                 }
//                             }
//                         },
//                         legend: {
//                             display: true,
//                             position: 'right',
//                             labels: {
//                                 usePointStyle: true,
//                                 generateLabels: function (chart) {
//                                     const data = chart.data;
//                                     const maxLabelsToShow = 3;

//                                     if (data.labels.length && data.datasets.length) {
//                                         const totalLabels = data.labels.length;
//                                         const visibleLabels = Math.min(totalLabels, maxLabelsToShow);

//                                         return data.labels.slice(0, visibleLabels).map(function (label, i) {
//                                             const dataset = data.datasets[0];
//                                             return {
//                                                 text: label,
//                                                 fillStyle: '#100F0F',
//                                                 strokeStyle: dataset.borderColor[i],
//                                                 lineWidth: 2,
//                                                 pointStyle: 'circle',
//                                                 fontColor: 'white',
//                                                 weight: 140,
//                                                 spacing: 10
//                                             };
//                                         });
//                                     }
//                                     return [];
//                                 },
//                             },
//                         },
//                     }
//                 }
//             });

//             return () => {
//                 myChart.destroy();
//             };
//         }
//     }, [taskData]);

//     const handleModalOpen = () => {
//         setModalOpen(!isModalOpen);
//     }

//     return (
//         <>
//             <div className="pie-chart">
//                 <div className='pie-chart__header'>
//                     <h1> Tasks - {topTwoLabels[0]} </h1>
//                     <p onClick={handleModalOpen}><svg xmlns="http://www.w3.org/2000/svg" width="25" height="27" viewBox="0 0 25 27" fill="none">
//                         <path d="M20.9139 12.5384L15.1082 5.78401C14.7084 5.31889 14.0612 5.31889 13.6806 5.78401C13.2808 6.24914 13.2808 7.00207 13.6806 7.44487L17.7731 12.2062L4.14404 12.2062C3.59207 12.2062 3.13514 12.7378 3.13514 13.3799C3.13514 14.0221 3.59207 14.5537 4.14404 14.5537L17.7541 14.5537L13.6806 19.3149C13.2808 19.7801 13.2808 20.533 13.6806 20.9759C13.871 21.1974 14.1374 21.3302 14.4039 21.3302C14.6704 21.3302 14.9179 21.2195 15.1273 20.9759L20.952 14.1993C21.1424 13.9778 21.2566 13.6678 21.2566 13.3578C21.2185 13.07 21.1043 12.76 20.9139 12.5384Z" fill="#D9D9D9" />
//                     </svg></p>
//                 </div>
//                 <div className='pie-chart__chart'>
//                     <canvas ref={chartRef}></canvas>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default PieChart;


import React, { useEffect, useRef, useState } from 'react';
import Chart from 'chart.js/auto';
import './style.scss';
import { generateRandomColors } from '../../../../../../../../../utils';
import Modal from 'react-modal';
import PieDrildown from './drildown/PieDrilldown';

const PieChart = ({ taskData }) => {
    const [topTwoLabels, setTopTwoLabels] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);
    const mainChartRef = useRef(null);

    useEffect(() => {
        if (mainChartRef.current && taskData && taskData.length > 0) {
            const sortedData = taskData.sort((a, b) => b.count - a.count);
            const topTwoLabels = sortedData.slice(0, 2).map(item => item.taskName);
            setTopTwoLabels(topTwoLabels);
            const values = sortedData.map(ele => ele.count);
            const labels = sortedData.map(ele => ele.taskName);
            const dynamicColors = Array.from({ length: values.length }, () => generateRandomColors());

            const mainChartCtx = mainChartRef.current.getContext('2d');
            const mainChart = new Chart(mainChartCtx, {
                type: 'pie',
                data: {
                    labels: labels,
                    datasets: [{
                        data: values,
                        backgroundColor: dynamicColors,
                        borderColor: dynamicColors,
                        borderWidth: 1
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        tooltip: {
                            callbacks: {
                                label: function (context) {
                                    return context.label + ': ' + context.formattedValue;
                                }
                            }
                        },
                        legend: {
                            display: true,
                            position: 'right',
                            labels: {
                                usePointStyle: true,
                                generateLabels: function (chart) {
                                    const data = chart.data;
                                    const maxLabelsToShow = 3;

                                    if (data.labels.length && data.datasets.length) {
                                        const totalLabels = data.labels.length;
                                        const visibleLabels = Math.min(totalLabels, maxLabelsToShow);

                                        return data.labels.slice(0, visibleLabels).map(function (label, i) {
                                            const dataset = data.datasets[0];
                                            return {
                                                text: label,
                                                fillStyle: '#100F0F',
                                                strokeStyle: dataset.borderColor[i],
                                                lineWidth: 3,
                                                pointStyle: 'circle',
                                                fontColor: 'white',
                                                weight: 140,
                                                spacing: 10
                                            };
                                        });
                                    }
                                    return [];
                                },
                            },
                        },
                    }
                }
            });

            return () => {
                mainChart.destroy();
            };
        }
    }, [taskData]);

    const handleModalOpen = () => {
        setModalOpen(!isModalOpen);
    }

    return (
        <>
            <Modal
                isOpen={isModalOpen}
                onRequestClose={handleModalOpen}
                style={{
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.9)',
                        'border-radius': 'none',
                    },
                    content: {
                        background: 'var(--dark-grey, #100F0F)',
                        width: '900px',
                        height: '400px',
                        color: "white",
                        top: "50%",
                        left: "50%",
                        transform: 'translate(-50%, -50%)',
                        borderRadius: '15px',
                        border: "none",
                        overflow: "hidden"
                    },
                }}
            >
                <div className='drilled-pie'>
                    <PieDrildown taskData={taskData} />
                </div>
            </Modal>
            <div className="pie-chart">
                <div className='pie-chart__header'>
                    <h1> Tasks - {topTwoLabels[0]} </h1>
                    <p onClick={handleModalOpen}><svg xmlns="http://www.w3.org/2000/svg" width="25" height="27" viewBox="0 0 25 27" fill="none">
                        <path d="M20.9139 12.5384L15.1082 5.78401C14.7084 5.31889 14.0612 5.31889 13.6806 5.78401C13.2808 6.24914 13.2808 7.00207 13.6806 7.44487L17.7731 12.2062L4.14404 12.2062C3.59207 12.2062 3.13514 12.7378 3.13514 13.3799C3.13514 14.0221 3.59207 14.5537 4.14404 14.5537L17.7541 14.5537L13.6806 19.3149C13.2808 19.7801 13.2808 20.533 13.6806 20.9759C13.871 21.1974 14.1374 21.3302 14.4039 21.3302C14.6704 21.3302 14.9179 21.2195 15.1273 20.9759L20.952 14.1993C21.1424 13.9778 21.2566 13.6678 21.2566 13.3578C21.2185 13.07 21.1043 12.76 20.9139 12.5384Z" fill="#D9D9D9" />
                    </svg></p>
                </div>
                <div className='pie-chart__chart'>
                    <canvas ref={mainChartRef}></canvas>
                </div>
            </div>
        </>
    );
};

export default PieChart;

